export class AddressModel {
    id: number;
    recipientName: string;
    street: string;
    number: string;
    zipCode: string;
    locality: string;
    country: string;
    text: string;
    url: string;
    navigationInstructions: string;

    format(withBr: boolean) {
        if (withBr) {
            return this.text.replace('\n', '<br/>')
        }
        return this.text.replace('\n', ' ');
    }

    toLabel(pRecipientName?: string) {
        const recipientName = this.recipientName ? this.recipientName : pRecipientName;
        return '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<DieCutLabel Version="8.0" Units="twips">\n' +
            '\t<PaperOrientation>Landscape</PaperOrientation>\n' +
            '\t<Id>ReturnAddressInt</Id>\n' +
            '\t<IsOutlined>false</IsOutlined>\n' +
            '\t<PaperName>11352 Return Address Int</PaperName>\n' +
            '\t<DrawCommands>\n' +
            '\t\t<RoundRectangle X="0" Y="0" Width="1440" Height="3060" Rx="180" Ry="180" />\n' +
            '\t</DrawCommands>\n' +
            '\t<ObjectInfo>\n' +
            '\t\t<AddressObject>\n' +
            '\t\t\t<Name>ADRESSE</Name>\n' +
            '\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n' +
            '\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />\n' +
            '\t\t\t<LinkedObjectName />\n' +
            '\t\t\t<Rotation>Rotation0</Rotation>\n' +
            '\t\t\t<IsMirrored>False</IsMirrored>\n' +
            '\t\t\t<IsVariable>True</IsVariable>\n' +
            '\t\t\t<GroupID>-1</GroupID>\n' +
            '\t\t\t<IsOutlined>False</IsOutlined>\n' +
            '\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>\n' +
            '\t\t\t<VerticalAlignment>Top</VerticalAlignment>\n' +
            '\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>\n' +
            '\t\t\t<UseFullFontHeight>True</UseFullFontHeight>\n' +
            '\t\t\t<Verticalized>False</Verticalized>\n' +
            '\t\t\t<StyledText>\n' +
            '\t\t\t\t<Element>\n' +
            '\t\t\t\t\t<String xml:space="preserve">' + (recipientName ? (recipientName + '\n') : '') +
            this.text + '</String>\n' +
            '\t\t\t\t\t<Attributes>\n' +
            '\t\t\t\t\t\t<Font Family="Arial" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />\n' +
            '\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />\n' +
            '\t\t\t\t\t</Attributes>\n' +
            '\t\t\t\t</Element>\n' +
            '\t\t\t</StyledText>\n' +
            '\t\t\t<ShowBarcodeFor9DigitZipOnly>False</ShowBarcodeFor9DigitZipOnly>\n' +
            '\t\t\t<BarcodePosition>AboveAddress</BarcodePosition>\n' +
            '\t\t\t<LineFonts>\n' +
            '\t\t\t\t<Font Family="Arial" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />\n' +
            '\t\t\t\t<Font Family="Arial" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />\n' +
            '\t\t\t\t<Font Family="Arial" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />\n' +
            '\t\t\t</LineFonts>\n' +
            '\t\t</AddressObject>\n' +
            '\t\t<Bounds X="130" Y="57" Width="2846" Height="1301" />\n' +
            '\t</ObjectInfo>\n' +
            '</DieCutLabel>';
    }
}
